import { render, staticRenderFns } from "./DownloadLinks.vue?vue&type=template&id=69055ac9&"
import script from "./DownloadLinks.vue?vue&type=script&lang=js&"
export * from "./DownloadLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconsGoogle: require('/home/reformatorischeomroep/reformatorischeomroep/nuxt/components/icons/Google.vue').default,IconsApple: require('/home/reformatorischeomroep/reformatorischeomroep/nuxt/components/icons/Apple.vue').default})
